import { css } from "lit";

export const EventFormSectionStyles = css`
  .form-section {
    padding: 24px;
    background: var(--color-pink);
  }
  .form-section-title {
    font-family: var(--font-text);
    font-size: var(--font-size-text);
    color: black;
    line-height: var(--line-height-text);
    margin: 0 0;
  }
  .form-row {
      display: flex;
      gap: 20px;
      width: 100%;
  }
`;
